module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/4@2x_962bda9a503e84676029c601cbc22f04.png";